import React from "react";
import styled from "styled-components";
import {media} from "assets/css/media";
import {useSelector} from "react-redux";
import {isAuthedSelector} from "modules/selectors";
import {NavLink} from "react-router-dom";
import {IMenuItem} from "modules/types";
import theme from "assets/css/theme";
import externalIcon from "assets/img/icons/external.png";

const Wrapper = styled.div`
	display: flex;
	@media (max-width: ${media.mobile}) {
		display: none;
	}
`;
const MenuItem = styled(NavLink)<{$isHideItem?: boolean}>`
	color: #ffffff;
	font-size: 14px;
	font-family: ${theme.base_bold_font};
	display: ${(props) => (props.$isHideItem ? "none" : "flex")};
	align-items: center;
	justify-content: center;
	margin: 0 10px;
	text-transform: uppercase;
	&:hover,
	&:active {
		opacity: 1;
	}
	img {
		margin-left: 10px;
	}
`;

interface IProps {
	menuItems: IMenuItem[];
}

const isOnSecretEnv = process.env.REACT_APP_IS_ON_SECRET === "true";

export const DesktopMenu: React.FC<IProps> = ({menuItems}) => {
	const isAuthed = useSelector(isAuthedSelector);
	const isHideItem = (items: IMenuItem) => (!isAuthed && items.isAuthed) || !items.link;
	const isOffSeason = process.env.REACT_APP_IS_OFF_SEASON === "true" && !isOnSecretEnv;
	return !isOffSeason ? (
		<Wrapper>
			{menuItems.map((item) =>
				!item.isExternal ? (
					<MenuItem $isHideItem={isHideItem(item)} key={item.label} to={item.link}>
						{window.getTranslations(item.label)}
					</MenuItem>
				) : (
					<MenuItem key={item.label} as={"a"} href={item.link} target={"_blank"} rel="noopener noreferrer">
						{window.getTranslations(item.label)}
						<img src={externalIcon} alt="External icon" />
					</MenuItem>
				)
			)}
		</Wrapper>
	) : null;
};
